import { render, staticRenderFns } from "./LightID.vue?vue&type=template&id=5b3722ac&scoped=true"
import script from "./LightID.vue?vue&type=script&lang=js"
export * from "./LightID.vue?vue&type=script&lang=js"
import style0 from "./LightID.vue?vue&type=style&index=0&id=5b3722ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3722ac",
  null
  
)

export default component.exports